import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export function useClearQueryParamsOnRouteChange(keysToClear: string[]) {
  const location = useLocation();
  const navigate = useNavigate();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;

    // Only act if the route has changed
    if (prevPathRef.current !== currentPath) {
      const query = new URLSearchParams(location.search);
      let changed = false;

      keysToClear.forEach((key) => {
        if (query.has(key)) {
          query.delete(key);
          changed = true;
        }
      });

      if (changed) {
        const newSearch = query.toString();
        navigate(
          `${currentPath}${newSearch ? '?' + newSearch : ''}`,
          { replace: true }
        );
      }

      prevPathRef.current = currentPath;
    }
  }, [location.pathname, location.search, navigate, keysToClear]);
}
